import { Link } from 'react-router-dom';
import { sportCategories } from '@/mocks/homeData';

export default function SportCategories() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            热门赛事分类
          </h2>
          <p className="text-sm text-foreground-600 max-w-[500px] mx-auto">
            覆盖全球超过30种体育项目，选择您喜爱的赛事，随时开始精彩投注体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {sportCategories.map((category) => (
            <Link
              key={category.id}
              to={`/category/${category.id}`}
              className="group relative bg-background-50 rounded-lg overflow-hidden border border-background-200/60 hover:border-primary-300/60 transition-all duration-300"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={category.image}
                  alt={`${category.name}赛事`}
                  title={`开云体育在线 - ${category.name}投注`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
                <div className="absolute bottom-3 left-4 right-4">
                  <div className="flex items-center gap-2">
                    <div className="w-7 h-7 flex items-center justify-center rounded-full bg-accent-500/90">
                      <i className={`${category.icon} text-background-50 text-sm`}></i>
                    </div>
                    <span className="text-base font-heading font-bold text-background-50">{category.name}</span>
                  </div>
                </div>
              </div>

              <div className="p-4">
                <p className="text-xs text-foreground-600 leading-relaxed mb-3">{category.description}</p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-primary-500 font-medium">
                    {category.eventCount} 场赛事
                  </span>
                  <div className="flex items-center gap-1 text-xs text-foreground-500 group-hover:text-primary-500 transition-colors duration-200">
                    <span className="whitespace-nowrap">查看详情</span>
                    <div className="w-3 h-3 flex items-center justify-center">
                      <i className="ri-arrow-right-s-line"></i>
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}